import React from 'react';
import { Row, Col} from 'reactstrap';
const FarmAPTThanksTo = () => {
    return (
            <>
                <Row>
                    <Col>
                        <h6>Data thanks to:</h6>
                        <img src="images/dairynz-logo.jpg" className="rounded thank-image" alt="DairyNZ logo"></img>
                        <img src="images/agresearch-logo.png" className="rounded thank-image" alt="AgResearch logo"></img>
                        <img src="images/national-science-challenges-logo.png" className="rounded thank-image" alt="National Science Challenge logo"></img>
                    </Col>
                </Row>
                <Row style={{ marginTop: "10px" }}>
                    <Col>
                    <p style={{ fontWeight: "lighter" }}>The Farm Action Prioritisation Tool (FarmAPT) contains management practices and mitigation actions for dairy. It was developed by DairyNZ with funding from the DairyNZ dairy farmer levy, in collaboration with AgResearch, and co-funded by the Our Land and Water National Science Challenge Rural Professionals Fund 2020-21.</p>
                    </Col>
                </Row>
            </>
        )
}
export default FarmAPTThanksTo